import axios from 'axios';

const axiosInt = axios.create({
  baseURL: process.env.REACT_APP_NODE_PATH
});

axiosInt.interceptors.response.use(
  (response) => response,
  (error) =>
    Promise.reject(
      (error.response && error.response.data) || 'There is an error!' + error
    )
);

export default axiosInt;

